<template minapp='mpx' xlang='wxml'>
  <view class='es-picker'>
    <view class="es-picker__toolbar" wx:if="{{showToolBar}}">
      <view class="es-picker__cancel" bindtap="onCancel">{{cancelText}}</view>
      <view class="es-picker__title">{{title}}</view>
      <view class="es-picker__confirm" bindtap="onConfirm">{{confirmText}}</view>
    </view>
    <view class="es-picker__columns">
      <picker-view
      indicator-style="{{itemStyle}}" 
      immediate-change="{{immediateChange}}"
      wx:style="{{rootStyle}}"
      value="{{value}}"
      bindchange="onChange"
      >
        <picker-view-column
        wx:for="{{columns}}"
        wx:key="index" 
        >
          <view 
          class="es-picker-column__text"
          wx:style="{{itemStyle}}"
          wx:for="{{item}}"
          wx:for-item="column"
          wx:for-index="columnsIndex"
          wx:key="column"
          >
          {{column}}
          </view>
        </picker-view-column>
      </picker-view>

    </view>
  </view>
</template>

<script>
import { createComponent } from '@didi/es-mpx-creator'
import props from './props'
createComponent({
  props: {
    ...props,  
    value: Array,
    columns: {
      type: Array,
      value: []
    },
  },
  computed: {
    itemStyle() {
      const style = this.indicatorStyle;
      return Object.keys(style)
      .map(key => `${key}:${style[key]}`)
      .join(';')
    },
    
    rootStyle() {
      const { height } = this;
      return {
        height
      }
    }
  },
  
  methods: {
    onChange(event) {
      this.$nextTick(() => {
        const { value } = event.detail;
        this.$trigger('input', { value })
      })
    },
    onCancel() {
      this.$trigger('cancle')
    },
    onConfirm() {
      this.$trigger('confirm', this.value)
    }
  }
})
</script>

<style scoped>
.es-picker{
  overflow: hidden;
  background: #fff;
  border-radius: 16px 16px 0  0;
}
.es-picker__toolbar{
  position: relative;
  display: flex;
  align-items: center;
  padding: 12px;
  font-size: 14px;
  justify-content: space-between;
}
.es-picker__toolbar::after{
  content: "";
  position: absolute;
  top: -50%;
  left: -50%;
  right: -50%;
  bottom: -50%;
  border-bottom: 1px solid #ebebeb;
  transform: scale(0.5);
  box-sizing: border-box;
}
.es-picker-column__text{
  display: flex;
  align-items: center;
  justify-content: center;
}
.es-picker__cancel{
  color: #969799;
}
.es-picker__confirm{
  color: #576b95;
}
.es-picker__title{
  max-width: 50%;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
   
</style>

<script name='json'>
  module.exports = { 
    "component": true
  }
</script>

